import { render } from "./ProjetGSB.vue?vue&type=template&id=150fbe4e&scoped=true"
import script from "./ProjetGSB.vue?vue&type=script&lang=js"
export * from "./ProjetGSB.vue?vue&type=script&lang=js"

import "./ProjetGSB.vue?vue&type=style&index=0&id=150fbe4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150fbe4e"]])

export default __exports__